import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CheckmarkOutline20, Time20 } from '@carbon/icons-react';
import { currentUser, selectScreenSize } from 'redux/session/selectors';
import { useSelector } from 'react-redux';
import { SCREEN_SIZE, APP_URL } from 'types';
import { ArrowLeft16 } from '@carbon/icons-react';
import {
  Switcher,
  SwitcherItem,
  SwitcherDivider,
  Link
} from 'carbon-components-react';
import UpgradePlan from '../UpgradePlan';

const showIcon = (completed: boolean) =>
  completed ? <CheckmarkOutline20 /> : <Time20 />;

const NotificationPanel: React.FC<Props> = ({ onOpenpanel, isTrialUser }) => {
  const user = useSelector(currentUser);
  const screenSize = useSelector(selectScreenSize);
  const [isLinked, setIsLinked] = useState(false);
  const { REACT_APP_HELP_FAQ_URL } = process.env;
  const history = useHistory();

  useEffect(() => {
    setIsLinked(user?.is_linked);
  }, [user]);

  return (
    <>
      {screenSize && screenSize === SCREEN_SIZE.SM && (
        <div className="panel-back bx--switcher__item">
          <div className="panel-back-btn" onClick={() => onOpenpanel('menu')}>
            <ArrowLeft16 />
          </div>
        </div>
      )}
      <div className="panel-title bx--switcher__item">
        <div className="bx--switcher__item-link no-clickable">
          SmarterWX Locate
        </div>
      </div>
      <div className="notification-status-title bx--switcher__item">
        <div className="bx--switcher__item-link no-clickable">
          Getting started
        </div>
      </div>
      <div
        className={`notification-status-item ${
          !user?.is_skip_dbyd ? 'completed' : ''
        }`}
      >
        <div className="notification-status-icon">
          {showIcon(!user?.is_skip_dbyd)}
        </div>
        <div className="bx--switcher__item">
          <div className="bx--switcher__item-link no-clickable">
            Complete sign up form
          </div>
        </div>
      </div>
      <div
        className={`notification-status-item ${isLinked ? 'completed' : ''}`}
      >
        <div className="notification-status-icon">{showIcon(isLinked)}</div>
        <div className="bx--switcher__item">
          <div
            className={`bx--switcher__item-link ${
              isLinked ? 'no-clickable' : ''
            }`}
          >
            {isLinked ? (
              <>Link BYDA account in your Profile</>
            ) : (
              <Link
                onClick={() => {
                  history.push(`${APP_URL.SETTINGS}?tab=profile`);
                }}
              >
                Link BYDA account in your Profile
              </Link>
            )}
          </div>
        </div>
      </div>
      <div
        className={`notification-status-item ${
          !user?.brand_new ? 'completed' : ''
        }`}
      >
        <div className="notification-status-icon">
          {showIcon(!user?.brand_new)}
        </div>
        <div className="bx--switcher__item">
          <div className="bx--switcher__item-link no-clickable">
            Create your first enquiry
          </div>
        </div>
      </div>
      <SwitcherDivider />
      <Switcher aria-label="Others">
        <SwitcherItem
          aria-label="Give feedback"
          onClick={() => onOpenpanel('feedback')}
        >
          Give feedback
        </SwitcherItem>

        <SwitcherItem
          aria-label="Help"
          href={REACT_APP_HELP_FAQ_URL}
          target="_blank"
        >
          Help
        </SwitcherItem>
      </Switcher>
      {isTrialUser && (
        <>
          <SwitcherDivider />
          <UpgradePlan />
        </>
      )}
    </>
  );
};

type Props = {
  onOpenpanel: Function;
  isTrialUser: boolean;
};

export default React.memo(NotificationPanel);
